import memoize from 'lodash/memoize';
import { mobileAppSearch } from 'adriel_backandfrontcommon';
import qs from 'qs';

const getData = R.prop('data');

const baseURL = '/utils';

async function fbInfo(userToken) {
    const res = await axios.get(`${baseURL}/fbInfo`, {
        params: {
            userToken,
        },
    });
    return res.data;
}

const getInterests = memoize((q) => {
    return axios.get(`/utils/userInterest?q=${q}`).then(getData);
});

const interestSuggestions = memoize((data) => {
    return axios.post('/utils/interestSuggestions', data).then(getData);
});

const getSuggestions = memoize((website) => {
    return axios
        .get(`/utils/suggestions`, {
            params: {
                website,
            },
        })
        .then(getData);
});

// caching only success case for retry
const searchApp = (() => {
    let cache = {};

    return (data = {}) => {
        const key = JSON.stringify(data);

        if (cache[key]) {
            return Promise.resolve(cache[key]);
        }

        return axios
            .post(`/utils/appSearch`, data)
            .then(getData)
            .then((data) => {
                cache[key] = data;
                return data;
            });
    };
})();

const searchAppstoreApp = (() => {
    let cache = {};

    return (term = '', user = {}) => {
        const key = term;

        if (cache[key]) {
            return Promise.resolve(cache[key]);
        }

        let lang = user.language;

        if (!['ko', 'en'].includes(lang)) {
            // fallback
            lang = 'en';
        }

        return mobileAppSearch
            .appStoreSearch(term, user.country, lang, window)
            .then((data) => {
                cache[key] = data;
                return data;
            });
    };
})();

const completeMobile = (data = {}) =>
    axios.post(`/utils/completeMobileAppUrls`, data).then(getData);

const businessLink = R.curryN(2, (token, data = {}) => {
    return axios
        .post('/business/link', {
            token,
            ...data,
        })
        .then(R.prop('data'));
});

async function fetchSmartOnboarding() {
    return axios.get('/smart-onboarding').then(R.prop('data'));
}

const getYelpSearchResults = ({ therm, location }) => {
    return axios
        .get('/utils/yelpSearch', {
            params: { therm: therm || null, location: location || null },
        })
        .then(R.prop('data'));
};

async function fetchGaEmails() {
    return axios.get('/utils/googleAnalyticsEmails').then(R.prop('data'));
}

async function saveUtm(queries = {}) {
    return axios
        .get(`/utils/utm?${qs.stringify(queries)}`)
        .then(R.prop('data'));
}

async function fetchBannedDomainList() {
    return axios.get('/utils/bannedEmailDomains').then(R.prop('data'));
}

export default {
    fbInfo,
    getInterests,
    getSuggestions,
    interestSuggestions,
    searchApp,
    completeMobile,
    searchAppstoreApp,
    businessLink,
    fetchSmartOnboarding,
    getYelpSearchResults,
    fetchGaEmails,
    saveUtm,
    fetchBannedDomainList,
};
